import { I18n } from "react-redux-i18n";
import { Modal, ModalFooter, ModalTitle, ModalBody, ModalHeader } from '@common/components/modal';;

import { getTestAttributes } from "@common/utils/tests";
import { Button } from "@common/components/Button";
import { MODULE_NAME } from "@modules/individuals";
import { Questionnaires } from "../questionnaires";
import { getPredefinedQuestionnaires, launchQuestionnaire } from "../../actions/individuals";

import "./questionnaire-open.styles.scss";

export const QuestionnaireOpen = (props) => {
  const localModuleName = `${MODULE_NAME}-questionnaire-open`;
  const { onClose, onSubmit, itemName, showErrorMessage, itemId } = props;
  const [submitting, setSubmitting] = React.useState(false);
  const [selectedQuestionnaire, setSelectedQuestionnaire] = React.useState();

  const handleSubmit = React.useCallback(async () => {
    setSubmitting(true);

    try {
      let currentUrl = window.location.href;
      const lastLocationChar = currentUrl[currentUrl.length - 1];

      if (lastLocationChar === '/') {
        currentUrl = currentUrl.slice(0, -1);
      }

      const { url } = await launchQuestionnaire(selectedQuestionnaire.inviteId, currentUrl, selectedQuestionnaire.fhq4);
      onSubmit(url);
    } catch (err) {
      setSubmitting(false);
      showErrorMessage(err?.entity || I18n.t("Operation failed"));
      console.error(err);
    }
  }, [onSubmit, showErrorMessage, selectedQuestionnaire?.inviteId]);

  return (
    <Modal
      show
      animation={false}
      bsSize="medium"
      backdrop="static"
      bsClass="bootstrap modal"
      className="IndividualsQuestionnaireOpen"
      onEscapeKeyDown={onClose}
      onHide={onClose}
    >
      <ModalHeader closeButton onHide={onClose}>
        <ModalTitle
          {...getTestAttributes(localModuleName, "header", "title")}
        >
          {I18n.t("Open Questionnaire for")} {itemName}
        </ModalTitle>
      </ModalHeader>

      <ModalBody>
        <Questionnaires 
          getFhq4Value={x => x?.fhq4}
          getIdValue={x => x?.inviteId}
          columns={[
            { name: "Questionnaire Name", fieldName: "questionnaireName", width: '25%' },
            { name: "Status", fieldName: "status", width: '16%' },
            { name: "Date Started", fieldName: "dateStarted", width: '16%' },
            { name: "Date Completed", fieldName: "dateCompleted", width: '16%' },
            { name: "Invited By", fieldName: "invitedBy", width: '25%' },
          ]}
          getData={() => getPredefinedQuestionnaires(itemId)} 
          selectedQuestionnaire={selectedQuestionnaire} 
          onSelectedQuestionnaireChange={setSelectedQuestionnaire}
        />
      </ModalBody>
      <ModalFooter>
        <Button
          disabled={submitting}
          {...getTestAttributes(MODULE_NAME, "cancel", "button")}
          onClick={onClose}
        >
          {I18n.t("Cancel")}
        </Button>
        <Button
          disabled={submitting || selectedQuestionnaire === undefined}
          bsStyle="primary"
          {...getTestAttributes(localModuleName, "submit", "button")}
          onClick={handleSubmit}
        >
          {submitting ? I18n.t("Loading") : I18n.t('Launch Questionnaire')}
        </Button>
      </ModalFooter>
    </Modal>
  );
};
